'use strict';

import PageNotFoundPage from './public/PageNotFoundPage';

var page = new PageNotFoundPage({
  container: '#error-page'
});

export default {}